<template>
  <vx-card :title="(this.id ? 'Edit' : 'Create') + ' Change Batch ED'">
    <div class="vx-row mb-6">
      <vs-button
        class="ml-4 mt-2"
        color="danger"
        icon-pack="feather"
        icon="icon-arrow-left"
        @click="handleBack()"
      >Back
      </vs-button>
    </div>

    <div class="flex md:flex-row">
      <div class="w-full pr-6 md:basis-1/2">
        <div class="mb-6 vx-row">
          <div class="flex items-center w-full vx-col sm:w-1/6">
            <span>Change Batch ID</span>
          </div>
          <div class="w-full vx-col sm:w-5/6">
            <vs-input class="w-full bg-grey-light" :value="code" disabled readonly></vs-input>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="flex items-center w-full vx-col sm:w-1/6">
            <span>Warehouse Code</span>
          </div>
          <div class="w-full vx-col sm:w-5/6">
            <Warehouse
              v-model="selected_warehouse"
              @selected="handleWarehouseSelected"
              :disabled="isEditMode"
            ></Warehouse>
            <span class="text-danger text-sm" v-show="errors.has('Warehouse')">{{ errors.first("Warehouse") }}</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="flex items-center w-full vx-col sm:w-1/6">
            <span>Note</span>
          </div>
          <div class="w-full vx-col sm:w-5/6">
            <vs-textarea v-model="notes" class="w-full" :counter="255" :max-lenght="255"/>
            <span class="text-danger text-sm" v-show="errors.has('Notes')">{{ errors.first("Notes") }}</span>
          </div>
        </div>
      </div>

      <div class="w-full md:basis-1/2">
        <Attachment
          v-model="fileAttachment"
        ></Attachment>
        <span class="text-danger text-sm" v-show="errors.has('fileAttachment')">{{
            errors.first("fileAttachment")
          }}</span>
      </div>
    </div>

    <div class="vx-col sm:w-5/5 w-full mb-2" v-for="(tr, indextr) in items" :key="indextr">

      <div class="vx-col sm:w-5/5 w-full mb-2">
        <div class="vx-row mb-2">
          <div class="vx-col w-5/12">
            <label class="vs-input--label">Warehouse Area</label>
          </div>
          <div class="vx-col w-6/12">
            <label class="vs-input--label">SKU</label>
          </div>
          <!--    for button add and remove items        -->
          <div class="vx-col w-1/12">
            <label class="vs-input--label">+ Items</label>
          </div>
        </div>
      </div>


      <div class="vx-row mb-2">
        <div class="vx-col w-5/12">
          <multiselect
            v-model="items[indextr].warehouseArea.selected"
            :options="optionWarehouseArea"
            :max-height="125"
            :show-labels="false"
            label="label"
            :allow-empty="false"
            :limit="5"
            placeholder="Type to search"
            :searchable="true"
            @select="fetchItems($event, indextr)"
          >
          </multiselect>
          <span class="text-danger text-sm" v-if="errors.has(`Items-${indextr}-warehouseArea`)">
            {{ errors.first(`Items-${indextr}-warehouseArea`) }}
          </span>
        </div>
        <div class="vx-col w-6/12">
          <multiselect
            v-model="items[indextr].sku.selected"
            :options="items[indextr].sku.options"
            :max-height="125"
            :show-labels="false"
            label="label"
            :allow-empty="false"
            :limit="3"
            placeholder="Type to search"
            :searchable="true"
            @select="fetchBatchExternal($event, indextr)"
          >
          </multiselect>
          <span class="text-danger text-sm" v-if="errors.has(`Items-${indextr}-sku`)">
            {{ errors.first(`Items-${indextr}-sku`) }}
          </span>
        </div>
        <div class="vx-col w-1/12" style="display: flex">

          <div class="vx-input-group flex">
            <vs-button
              v-if="items.length > 1"
              @click.stop="handleRemoveItems(indextr)"
              size="small"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              style="margin-right: 5px"
              title="Remove Row"
            />

            <vs-button
              v-if="indextr === items.length - 1"
              @click.stop="handleAddItems"
              size="small"
              color="success"
              icon-pack="feather"
              icon="icon-plus"
              title="Add Row"
            />
          </div>
        </div>
      </div>

      <div class="vx-col sm:w-5/5 w-full mb-2">
        <div class="vx-row mb-2">

          <div class="vx-col w-3/12">
            <label class="vs-input--label">Batch External / ED</label>
          </div>
          <div class="vx-col w-2/12">
            <label class="vs-input--label">Date IN</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">Handling Unit</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">Available Qty</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">Available Qty UOM</label>
          </div>
        </div>

        <div class="vx-row mb-2">

          <div class="vx-col w-3/12">
            <multiselect
              v-model="items[indextr].batchExternal.selected"
              :options="items[indextr].batchExternal.options"
              :max-height="125"
              :show-labels="false"
              label="label"
              :allow-empty="false"
              :limit="3"
              placeholder="Type to search"
              :searchable="true"
              @select="fetchDateIn($event, indextr)"
              @input="onBatchExternalChanged(indextr)"
            >
            </multiselect>
            <span class="text-danger text-sm" v-if="errors.has(`Items-${indextr}-batchExternal`)">
              {{ errors.first(`Items-${indextr}-batchExternal`) }}
            </span>
          </div>

          <div class="vx-col w-2/12">
            <multiselect
              v-model="items[indextr].dateIn.selected"
              :options="items[indextr].dateIn.options"
              :max-height="125"
              :show-labels="false"
              label="label"
              :allow-empty="false"
              :limit="3"
              placeholder="Type to search"
              :searchable="true"
              @select="fetchUnit($event, indextr)"
            >
            </multiselect>
            <span class="text-danger text-sm" v-if="errors.has(`Items-${indextr}-dateIn`)">
              {{ errors.first(`Items-${indextr}-dateIn`) }}
            </span>
          </div>

          <div class="vx-col w-1/12">
            <multiselect
              v-model="items[indextr].unit.selected"
              :options="items[indextr].unit.options"
              :max-height="125"
              :show-labels="false"
              label="label"
              :allow-empty="false"
              :limit="3"
              placeholder=""
              :searchable="true"
              @select="fetchQtyAvailable($event, indextr)"
            >
            </multiselect>
            <span class="text-danger text-sm" v-if="errors.has(`Items-${indextr}-unit`)">
              {{ errors.first(`Items-${indextr}-unit`) }}
            </span>
          </div>

          <div class="vx-col w-1/12">
            <vs-input
              class="w-full"
              v-model="items[indextr].qty"
              :disabled="true"
            />
          </div>

          <div class="vx-col w-1/12">
            <vs-input
              class="w-full"
              v-model="items[indextr].qtyUom"
              :disabled="true"
            />
          </div>
        </div>
      </div>

      <!--      for items.line-->
      <div class="vx-col sm:w-5/5 w-full mb-2">
        <div class="vx-row mb-2">

          <div class="vx-col w-1/12">
            <label class="vs-input--label">New Handling Unit</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">New Qty</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">New Qty UOM</label>
          </div>
          <div class="vx-col w-2/12">
            <label class="vs-input--label">New Batch External</label>
          </div>
          <div class="vx-col w-2/12">
            <label class="vs-input--label">New Expired Date</label>
          </div>
          <div class="vx-col w-1/12">
            <label class="vs-input--label">+ line</label>
          </div>

        </div>

        <div
          class="vx-row mb-2"
          v-for="(line, lineIndex) in items[indextr].line"
          :key="lineIndex"
        >
          <div class="vx-col w-1/12">
            <multiselect
              v-model="line.newUnit.selected"
              :options="items[indextr].newUnitOptions"
              :max-height="125"
              :show-labels="false"
              label="label"
              :allow-empty="false"
              :limit="3"
              placeholder=""
              :searchable="true"
              @input="onNewUnitChanged(indextr, lineIndex)"
            >
            </multiselect>
            <span class="text-danger text-sm" v-if="errors.has(`Items-${indextr}-line-${lineIndex}-newUnit`)">
              {{ errors.first(`Items-${indextr}-line-${lineIndex}-newUnit`) }}
            </span>
          </div>

          <div class="vx-col w-1/12">
            <vs-input
              class="w-full"
              v-model="line.newQty"
              type="number"
              min="1"
              @input="() => { getTotalNewQtyUom(indextr, lineIndex); calculateTotalNewQtyUom(indextr); }"
              @keypress="onlyNumber($event)"
            />
            <span class="text-danger text-sm" v-if="errors.has(`Items-${indextr}-line-${lineIndex}-newQty`)">
              {{ errors.first(`Items-${indextr}-line-${lineIndex}-newQty`) }}
            </span>
          </div>

          <div class="vx-col w-1/12">
            <vs-input
              class="w-full"
              v-model="line.newQtyUom"
              :disabled="true"
            />
          </div>

          <div class="vx-col w-2/12">
            <vs-input
              class="w-full"
              v-model="line.newBatchExternal"
            />
            <span class="text-danger text-sm" v-if="errors.has(`Items-${indextr}-line-${lineIndex}-newBatchExternal`)">
              {{ errors.first(`Items-${indextr}-line-${lineIndex}-newBatchExternal`) }}
            </span>
          </div>

          <div class="vx-col w-2/12">
            <Datepicker
              v-model="line.newExpiredDate"
              :placeholder="'Select date'"
              :calendar-class="'datepicker-above'"
              :format="dateFormat"
            />
            <span class="text-danger text-sm" v-if="errors.has(`Items-${indextr}-line-${lineIndex}-newExpiredDate`)">
              {{ errors.first(`Items-${indextr}-line-${lineIndex}-newExpiredDate`) }}
            </span>
          </div>

          <div class="vx-col w-1/12" style="display: flex">
            <div class="vx-input-group flex">
              <vs-button
                v-if="items[indextr].line.length > 1"
                @click.stop="handleRemoveLine(indextr, lineIndex)"
                size="small"
                color="danger"
                icon-pack="feather"
                icon="icon-trash"
                style="margin-right: 5px"
                title="Remove Row"
              />
              <vs-button
                v-if="lineIndex === items[indextr].line.length - 1"
                @click.stop="handleAddLine(indextr)"
                size="small"
                color="success"
                icon-pack="feather"
                icon="icon-plus"
                title="Add Row"
              />
            </div>
          </div>
        </div>
      </div>

      <!--   for total new qty uom   -->
      <div class="vx-row mb-2">
        <div class="vx-col w-1/12"></div>
        <div class="vx-col w-1/12"></div>
        <div class="vx-col w-1/12">
          <label class="vs-input--label">Total New Qty UOM</label>
          <vs-input
            class="w-full"
            v-model="items[indextr].totalNewQtyUom"
            :disabled="true"
          />
        </div>
      </div>

      <vs-divider></vs-divider>
    </div>

    <br>

    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/1 w-full">
        <div style="
                    position: absolute;
                    left: 50%;
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                ">
          <vs-button class="mr-3 mb-2" @click="handleSave">Save</vs-button>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import Attachment from "./component/Attachment.vue";
import Date from "./component/Date.vue";
import Warehouse from "./component/Warehouse.vue";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  components: {
    Warehouse,
    Date,
    Attachment,
    Datepicker
  },
  data() {
    return {
      id: this.$route.query.id ? parseInt(this.$route.query.id) : null,
      code: "Auto Generated",
      selected_warehouse: null,
      notes: null,
      fileAttachment: [],
      optionWarehouseArea: [],
      items: [
        {
          warehouseArea: {
            selected: null,
            options: [],
          },
          sku: {
            selected: null,
            options: [],
          },
          batchExternal: {
            selected: null,
            options: [],
          },
          dateIn: {
            selected: null,
            options: [],
          },
          unit: {
            selected: null,
            options: [],
          },
          qty: null,
          qtyUom: null,
          newUnitOptions: [],
          totalNewQtyUom: null,
          line: [
            {
              newUnit: {
                selected: null,
              },
              newQty: null,
              newQtyUom: null,
              newBatchExternal: null,
              newExpiredDate: null,
            }
          ]
        }
      ],
    };
  },
  methods: {
    handleBack() {
      this.$router.push({
        name: "manage-change-batch",
      });
    },
    handleWarehouseSelected(val) {
      this.selected_warehouse = val;
      this.onWarehouseChanges();
      this.fetchWarehouseArea(val.id);
    },
    fetchWarehouseArea(warehouseID) {
      const baseUrl = `/api/wms/v1/master/warehouse-area-storage`;
      this.$http
        .get(baseUrl, {
          params: {
            order: "name",
            sort: "asc",
            warehouse_id: warehouseID,
          }
        })
        .then(resp => {
          if (resp.code === 200) {
            this.optionWarehouseArea = resp.data.records.map(x => ({
              ...x,
              label: `${x.code} - ${x.name}`
            }));
          } else {
            this.$vs.notify({
              title: "Error",
              text: resp.message,
              color: "danger",
              icon: "icon-close",
            });
          }
        });
    },
    fetchItems(val, index) {

      this.items[index].sku = {
        selected: null,
        options: [],
      };
      this.items[index].batchExternal = {
        selected: null,
        options: [],
      };
      this.items[index].dateIn = {
        selected: null,
        options: [],
      };
      this.items[index].unit = {
        selected: null,
        options: [],
      };
      this.items[index].qty = null;
      this.items[index].qtyUom = null;
      this.items[index].newUnitOptions = [];

      if (this.items[index].line.length > 1) {
        this.items[index].line.splice(1);
      }
      const line = this.items[index].line[0];
      line.newUnit = {
        selected: null,
      };
      line.newQty = null;
      line.newQtyUom = null;
      line.newBatchExternal = null;
      line.newExpiredDate = null;

      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/wms/item-stock/group-items", {
          params: {
            order: "item_name",
            sort: "asc",
            warehouse_id: this.selected_warehouse.id,
            warehouse_area_id: val.id,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const options = resp.data.records.map(item => ({
              ...item,
              label: `${item.sku_code} - ${item.item_name}`,
            }));
            this.items[index].sku.options = options;
          }
        });
    },
    fetchBatchExternal(val, index) {

      this.items[index].batchExternal = {
        selected: null,
        options: [],
      };
      this.items[index].dateIn = {
        selected: null,
        options: [],
      };
      this.items[index].unit = {
        selected: null,
        options: [],
      };
      this.items[index].qty = null;
      this.items[index].qtyUom = null;
      this.items[index].newUnitOptions = [];

      if (this.items[index].line.length > 1) {
        this.items[index].line.splice(1);
      }
      const line = this.items[index].line[0];
      line.newUnit = {
        selected: null,
      };
      line.newQty = null;
      line.newQtyUom = null;
      line.newBatchExternal = null;
      line.newExpiredDate = null;

      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/wms/item-stock/group-batch", {
          params: {
            warehouse_id: this.selected_warehouse.id,
            warehouse_area_id: this.items[index].warehouseArea.selected.id,
            sku_code: val.sku_code,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const options = resp.data.records.map(item => ({
              ...item,
              label: `${item.batch_external} / ${item.expired_date ? moment(item.expired_date).format('YYYY-MM-DD') : ''}`
            }));
            this.items[index].batchExternal.options = options;
          }
        });
    },
    fetchDateIn(val, index) {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/wms/item-stock/get-date-in", {
          params: {
            warehouse_id: this.selected_warehouse.id,
            warehouse_area_id: this.items[index].warehouseArea.selected.id,
            sku_code: this.items[index].sku.selected.sku_code,
            batch_external: val.batch_external,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const options = resp.data.records.map(item => ({
              ...item,
              label: item.in_time ? moment(item.in_time).format('YYYY-MM-DD') : ''
            }));
            this.items[index].dateIn.options = options;
          }
        });
    },
    fetchUnit(val, index) {

      this.items[index].unit = {
        selected: null,
        options: [],
      };
      this.items[index].qty = null;
      this.items[index].qtyUom = null;
      this.items[index].newUnitOptions = [];

      if (this.items[index].line.length > 1) {
        this.items[index].line.splice(1);
      }

      const line = this.items[index].line[0];
      line.newUnit = {
        selected: null,
      };
      line.newQty = null;
      line.newQtyUom = null;
      line.newBatchExternal = null;
      line.newExpiredDate = null;


      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/wms/item-stock/get-unit-available", {
          params: {
            warehouse_id: this.selected_warehouse.id,
            warehouse_area_id: this.items[index].warehouseArea.selected.id,
            sku_code: this.items[index].sku.selected.sku_code,
            expired_date: this.items[index].dateIn.selected.expired_date,
            batch_external: this.items[index].batchExternal.selected.batch_external,
            date_in: val.in_time,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const options = resp.data.records.map(item => ({
              ...item,
              label: item.unit
            }));

            this.items[index].unit.options = options;
          }
        });
    },
    fetchQtyAvailable(val, index) {

      this.items[index].qty = null;
      this.items[index].qtyUom = null;
      this.items[index].newUnitOptions = [];

      if (this.items[index].line.length > 1) {
        this.items[index].line.splice(1);
      }

      const line = this.items[index].line[0];
      line.newUnit = {
        selected: null,
      };
      line.newQty = null;
      line.newQtyUom = null;
      line.newBatchExternal = null;
      line.newExpiredDate = null;

      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/wms/item-stock/qty-available", {
          params: {
            warehouse_id: this.selected_warehouse.id,
            warehouse_area_id: this.items[index].warehouseArea.selected.id,
            sku_code: this.items[index].sku.selected.sku_code,
            expired_date: this.items[index].batchExternal.selected.expired_date,
            batch_external: this.items[index].batchExternal.selected.batch_external,
            date_in: this.items[index].dateIn.selected.in_time,
            unit: val.unit,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            this.items[index].qty = resp.data.amount;
            this.items[index].qtyUom = resp.data.amount * resp.data.amount_uom;
            this.fetchNewUnit(this.items[index].sku.selected.sku_code, index);
          }
        });
    },
    fetchNewUnit(sku_code, index) {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/master/item-unit-sku-code", {
          params: {
            sku_code: sku_code,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const options = resp.data.records.map(item => ({
              ...item,
              label: item.name
            }));

            this.items[index].newUnitOptions = options;
          }
        });
    },
    getTotalNewQtyUom(indextr, lineIndex) {
      const line = this.items[indextr].line[lineIndex];
      if (line.newUnit.selected && line.newQty && line.newQty > 0) {
        line.newQtyUom = line.newQty * line.newUnit.selected.amount_uom;
      } else {
        line.newQtyUom = null;
        if (line.newQty <= 0) {
          line.newQty = null;
        }
      }
    },
    onlyNumber(e) {
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    handleRemoveItems(indextr) {
      if (this.items.length > 1) {
        this.items.splice(indextr, 1);
      }
    },
    handleAddItems() {
      this.items.push({
        warehouseArea: {
          selected: null,
          options: [],
        },
        sku: {
          selected: null,
          options: [],
        },
        batchExternal: {
          selected: null,
          options: [],
        },
        dateIn: {
          selected: null,
          options: [],
        },
        unit: {
          selected: null,
          options: [],
        },
        qty: null,
        qtyUom: null,
        newUnitOptions: [],
        line: [
          {
            newUnit: {
              selected: null,
              options: [],
            },
            newQty: null,
            newQtyUom: null,
            newBatchExternal: null,
            newExpiredDate: null,
          },
        ],
      });
    },
    handleRemoveLine(indextr, lineIndex) {
      if (this.items[indextr].line.length > 1) {
        this.items[indextr].line.splice(lineIndex, 1);
        this.calculateTotalNewQtyUom(indextr);
      }
    },
    handleAddLine(indextr) {
      this.items[indextr].line.push({
        newUnit: {
          selected: null,
        },
        newQty: null,
        newQtyUom: null,
        newBatchExternal: null,
        newExpiredDate: null,
      });
    },
    handleSave() {
      this.errors.clear();

      this.$validator.validateAll().then((result) => {
        if (this.selected_warehouse === null) {
          this.errors.add({field: "Warehouse", msg: "Warehouse is required"});
        }

        if (!this.notes || this.notes.trim() === "") {
          this.errors.add({ field: "Notes", msg: "Note is required" });
        } else if (this.notes.length > 255) {
          this.errors.add({ field: "Notes", msg: "Note max 255 characters" });
        }

        if (this.fileAttachment.length === 0) {
          this.errors.add({
            field: "fileAttachment",
            msg: "File Attachment is required",
          });
        }

        // validate unique items batch expired date, date in, and handling unit

        const itemKeys = new Set();
        this.items.forEach((item, index) => {
          const key = [
            item.warehouseArea.selected && item.warehouseArea.selected.id,
            item.sku.selected && item.sku.selected.sku_code,
            item.batchExternal.selected && item.batchExternal.selected.batch_external,
            item.dateIn.selected && (item.dateIn.selected.in_time || item.dateIn.selected.date_in),
            item.unit.selected && item.unit.selected.unit
          ].join('|');

          if (itemKeys.has(key)) {
            this.errors.add({
              field: `Items-${index}-sku`,
              msg: `Item ${index + 1}: Combination of Warehouse Area, SKU, Batch External / ED, Date IN, and Handling Unit must be unique.`,
            });
          } else {
            itemKeys.add(key);
          }
        });

        // Cross-item validation for New Batch External and New Expired Date per SKU
        const skuBatchLineMap = {}; // { sku: { batch: [{ expired, itemIdx, lineIdx }] } }

        this.items.forEach((item, itemIdx) => {
          const sku = item.sku.selected && item.sku.selected.sku_code;
          item.line.forEach((line, lineIdx) => {
            const batch = line.newBatchExternal;
            const expired = line.newExpiredDate && this.dateFormat(line.newExpiredDate);
            if (sku && batch) {
              if (!skuBatchLineMap[sku]) skuBatchLineMap[sku] = {};
              if (!skuBatchLineMap[sku][batch]) skuBatchLineMap[sku][batch] = [];
              skuBatchLineMap[sku][batch].push({expired, itemIdx, lineIdx});
            }
          });
        });

        // Now check for duplicates
        Object.keys(skuBatchLineMap).forEach(sku => {
          Object.keys(skuBatchLineMap[sku]).forEach(batch => {
            const lines = skuBatchLineMap[sku][batch];
            const expiredDates = [...new Set(lines.map(l => l.expired))];
            if (expiredDates.length > 1) {
              const itemNumbers = [...new Set(lines.map(l => l.itemIdx + 1))].join(', ');
              const lineNumbers = lines.map(l => l.lineIdx + 1).join(', ');
              lines.forEach(l => {
                this.errors.add({
                  field: `Items-${l.itemIdx}-line-${l.lineIdx}-newBatchExternal`,
                  msg: `SKU ${sku}: New Batch External "${batch}" duplicated on items ${itemNumbers} and line ${lineNumbers}`,
                });
              });
            }
          });
        });

        let hasDialogError = false;
        this.items.forEach((item, index) => {
          if (!item.warehouseArea.selected) {
            this.errors.add({
              field: `Items-${index}-warehouseArea`,
              msg: `Item ${index + 1}: Warehouse Area is required`,
            });
          }
          if (!item.sku.selected) {
            this.errors.add({
              field: `Items-${index}-sku`,
              msg: `Item ${index + 1}: SKU is required`,
            });
          }
          if (!item.batchExternal.selected) {
            this.errors.add({
              field: `Items-${index}-batchExternal`,
              msg: `Item ${index + 1}: Batch External is required`,
            });
          }
          if (!item.dateIn.selected) {
            this.errors.add({
              field: `Items-${index}-dateIn`,
              msg: `Item ${index + 1}: Date In is required`,
            });
          }
          if (!item.unit.selected) {
            this.errors.add({
              field: `Items-${index}-unit`,
              msg: `Item ${index + 1}: Handling Unit is required`,
            });
          }

          let totalNewQtyUom = 0;

          const batchExternalUnitMap = {};
          item.line.forEach((line, lineIndex) => {
            if (!line.newUnit.selected) {
              this.errors.add({
                field: `Items-${index}-line-${lineIndex}-newUnit`,
                msg: `Item ${index + 1}, Line ${lineIndex + 1}: New Unit is required`,
              });
            }

            if (!line.newQty) {
              this.errors.add({
                field: `Items-${index}-line-${lineIndex}-newQty`,
                msg: `Item ${index + 1}, Line ${lineIndex + 1}: New Qty is required`,
              });
            }

            const unitName = line.newUnit.selected && line.newUnit.selected.name;
            const batchKey = `${line.newBatchExternal || ""}_${unitName || ""}`;
            if (line.newBatchExternal && unitName) {
              if (!batchExternalUnitMap[batchKey]) {
                batchExternalUnitMap[batchKey] = [];
              }
              batchExternalUnitMap[batchKey].push(lineIndex);
            }

            if (!line.newExpiredDate) {
              this.errors.add({
                field: `Items-${index}-line-${lineIndex}-newExpiredDate`,
                msg: `Item ${index + 1}, Line ${lineIndex + 1}: New Expired Date is required`,
              });
            }

            if (line.newQtyUom) {
              totalNewQtyUom += parseFloat(line.newQtyUom);
            }
          });

          Object.keys(batchExternalUnitMap).forEach(key => {
            if (batchExternalUnitMap[key].length > 1) {
              batchExternalUnitMap[key].forEach(lineIndex => {
                this.errors.add({
                  field: `Items-${index}-line-${lineIndex}-newBatchExternal`,
                  msg: `New Batch External can't be duplicate for the same New Handling Unit`,
                });
              });
            }
          });

          if (totalNewQtyUom > item.qtyUom) {
            hasDialogError = true;
            this.$vs.dialog({
              type: "alert",
              color: "danger",
              title: "Information",
              text: `Item ${index + 1}: Total Qty UOM (${totalNewQtyUom}) exceeds available Qty UOM (${item.qtyUom})`,
              acceptText: "OK",
            });
          }
        });

        if (result && this.errors.items.length === 0 && !hasDialogError) {
          if (this.id) {
            this.putData();
          } else {
            this.postData();
          }
        }
      });
    },
    putData() {
      let form = new FormData();

      form.append("warehouse_id", this.selected_warehouse.id);
      form.append("note", this.notes);

      // Attachment
      var attachment_id;
      for (let index = 0; index < this.fileAttachment.length; index++) {
        if (typeof this.fileAttachment[index].id === "undefined") {
          attachment_id = 0;
        } else {
          attachment_id = this.fileAttachment[index].id;
        }
        form.append("attachment_id[]", attachment_id);
        form.append("attachments[]", this.fileAttachment[index].File);
      }

      const items = this.items.map((item) => {
        const expiredDate = item.batchExternal.selected && item.batchExternal.selected.expired_date
          ? moment(item.batchExternal.selected.expired_date).format('YYYY-MM-DD')
          : '';
        const dateIn = item.dateIn.selected && item.dateIn.selected.in_time
          ? moment(item.dateIn.selected.in_time).format('YYYY-MM-DD')
          : '';

        const itemObj = {
          warehouse_area_id: (item.warehouseArea.selected && item.warehouseArea.selected.id),
          sku_code: (item.sku.selected && item.sku.selected.sku_code),
          batch_external: (item.batchExternal.selected && item.batchExternal.selected.batch_external),
          expired_date: expiredDate,
          date_in: dateIn,
          unit: (item.unit.selected && item.unit.selected.unit),
          qty: item.qty,
          qty_uom: item.qtyUom,
          line: (item.line).map((line) => ({
            new_unit: (line.newUnit.selected && line.newUnit.selected.name),
            new_qty: parseFloat(line.newQty),
            new_qty_uom: line.newQtyUom,
            new_batch_external: line.newBatchExternal,
            new_expired_date: moment(line.newExpiredDate).format('YYYY-MM-DD'),
          })),
        };
        return itemObj;
      });

      form.append("items", JSON.stringify(items));

      this.$vs.loading();
      this.$http.put(`/api/wms/v1/change-batch/${this.id}`, form)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            this.$vs.notify({
              title: "Success",
              text: "change batch has been updated",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.handleBack();
          } else {
            this.$vs.notify({
              title: "Error",
              text: resp.message,
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-triangle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.response,
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-triangle",
          });
        });
    },
    postData() {
      let form = new FormData();

      form.append("warehouse_id", this.selected_warehouse.id);
      form.append("note", this.notes);

      // Attachments
      for (let i = 0; i < this.fileAttachment.length; i++) {
        form.append("attachments[]", this.fileAttachment[i].File);
      }

      const items = this.items.map((item) => {
        const expiredDate = item.batchExternal.selected && item.batchExternal.selected.expired_date
          ? moment(item.batchExternal.selected.expired_date).format('YYYY-MM-DD')
          : '';
        const dateIn = item.dateIn.selected && item.dateIn.selected.in_time
          ? moment(item.dateIn.selected.in_time).format('YYYY-MM-DD')
          : '';

        const itemObj = {
          warehouse_area_id: (item.warehouseArea.selected && item.warehouseArea.selected.id),
          sku_code: (item.sku.selected && item.sku.selected.sku_code),
          batch_external: (item.batchExternal.selected && item.batchExternal.selected.batch_external),
          expired_date: expiredDate,
          date_in: dateIn,
          unit: (item.unit.selected && item.unit.selected.unit),
          qty: item.qty,
          qty_uom: item.qtyUom,
          line: (item.line).map((line) => ({
            new_unit: (line.newUnit.selected && line.newUnit.selected.name),
            new_qty: parseFloat(line.newQty),
            new_qty_uom: line.newQtyUom,
            new_batch_external: line.newBatchExternal,
            new_expired_date: moment(line.newExpiredDate).format('YYYY-MM-DD'),
          })),
        };
        return itemObj;
      });

      form.append("items", JSON.stringify(items));

      this.$vs.loading();
      this.$http.post("/api/wms/v1/change-batch", form)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            this.$vs.notify({
              title: "Success",
              text: "change batch has been saved",
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-check",
            });
            this.handleBack();
          } else {
            this.$vs.notify({
              title: "Error",
              text: resp.message,
              color: "danger",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-alert-triangle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.response,
            color: "danger",
            position: "top-right",
            iconPack: "feather",
            icon: "icon-alert-triangle",
          });
        });
    },
    getData() {
      this.$vs.loading();
      this.$http.get(`/api/wms/v1/change-batch/${this.id}`)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const data = resp.data;
            this.code = data.change_batch.Code;
            this.selected_warehouse = {
              id: data.change_batch.WarehouseID,
              code: data.change_batch.WarehouseCode,
              name: data.change_batch.WarehouseName,
              label: `${data.change_batch.WarehouseCode} - ${data.change_batch.WarehouseName}`
            }
            this.notes = data.change_batch.Note;

            this.fileAttachment = data.change_batch_attachments.map(attachment => ({
              id: attachment.id,
              NameFile: attachment.FileName,
              FileUrl: attachment.FileUrl,
            }));

            this.items = data.change_batch_lines.map(lineItem => ({
              warehouseArea: {selected: {id: lineItem.warehouse_area_id}, options: []},
              sku: {selected: {sku_code: lineItem.sku_code, item_name: lineItem.item_name}, options: []},
              batchExternal: {
                selected: {batch_external: lineItem.batch_external, expired_date: lineItem.expired_date},
                options: []
              },
              dateIn: {selected: {in_time: lineItem.date_in, expired_date: lineItem.expired_date}, options: []},
              unit: {selected: {unit: lineItem.unit}, options: []},
              qty: lineItem.qty,
              qtyUom: lineItem.qty_uom,
              newUnitOptions: [],
              totalNewQtyUom: null,
              line: lineItem.line.map(subLine => ({
                newUnit: {selected: {name: subLine.new_unit}},
                newQty: subLine.new_qty,
                newQtyUom: subLine.new_qty_uom,
                newBatchExternal: subLine.new_batch_external,
                newExpiredDate: subLine.new_expired_date,
              })),
            }));

            // Fetch options for each item
            this.fetchWarehouseAreaEdit(this.selected_warehouse.id);
            this.items.forEach((item, idx) => {
              this.fetchItemsEdit(idx, this.selected_warehouse.id, item.warehouseArea.selected.id);
              this.fetchBatchExternalEdit(idx, this.selected_warehouse.id, item.warehouseArea.selected.id, item.sku.selected.sku_code);
              this.fetchDateInEdit(idx, this.selected_warehouse.id, item.warehouseArea.selected.id, item.sku.selected.sku_code, item.batchExternal.selected.batch_external);
              this.fetchUnitEdit(idx, this.selected_warehouse.id, item.warehouseArea.selected.id, item.sku.selected.sku_code, item.batchExternal.selected.expired_date, item.batchExternal.selected.batch_external, item.dateIn.selected.in_time);
              this.fetchQtyAvailableEdit(idx, this.selected_warehouse.id, item.warehouseArea.selected.id, item.sku.selected.sku_code, item.batchExternal.selected.expired_date, item.batchExternal.selected.batch_external, item.dateIn.selected.in_time, item.unit.selected.unit);
              this.fetchNewUnitEdit(item.sku.selected.sku_code, idx);
              this.calculateTotalNewQtyUom(idx);
            });

          } else {
            this.$vs.notify({
              title: "Error",
              text: resp.message,
              color: "danger",
              iconPack: "feather",
              icon: "icon-close",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-triangle",
          });
        });
    },
    onNewUnitChanged(indextr, lineIndex) {
      const line = this.items[indextr].line[lineIndex];

      line.newQty = null;
      line.newQtyUom = null;
      line.newBatchExternal = null;
      line.newExpiredDate = null;
    },
    onBatchExternalChanged(index) {
      const item = this.items[index];

      item.dateIn.selected = null;
      item.dateIn.options = [];

      item.unit.selected = null;
      item.unit.options = [];

      item.qty = null;
      item.qtyUom = null;

      if (item.line.length > 1) {
        item.line.splice(1);
      }

      const line = item.line[0];
      line.newUnit.selected = null;
      line.newQty = null;
      line.newQtyUom = null;
      line.newBatchExternal = null;
      line.newExpiredDate = null;
    },
    onWarehouseChanges() {
      this.items = [this.items[0]];

      this.items[0].warehouseArea = {
        selected: null,
        options: [],
      };
      this.items[0].sku = {
        selected: null,
        options: [],
      };
      this.items[0].batchExternal = {
        selected: null,
        options: [],
      };
      this.items[0].dateIn = {
        selected: null,
        options: [],
      };
      this.items[0].unit = {
        selected: null,
        options: [],
      };
      this.items[0].qty = null;
      this.items[0].qtyUom = null;
      this.items[0].newUnitOptions = [];

      this.items[0].line = [
        {
          newUnit: {
            selected: null,
          },
          newQty: null,
          newQtyUom: null,
          newBatchExternal: null,
          newExpiredDate: null,
        },
      ];
    },
    fetchWarehouseAreaEdit(warehouseID) {
      const baseUrl = `/api/wms/v1/master/warehouse-area-storage`;
      this.$http.get(baseUrl, {
        params: {
          order: "name",
          sort: "asc",
          warehouse_id: warehouseID,
        }
      }).then(resp => {
        if (resp.code === 200) {
          let options = resp.data.records.map(x => ({
            ...x,
            label: `${x.code} - ${x.name}`
          }));

          this.items.forEach(item => {
            const selected = item.warehouseArea.selected;
            if (selected && !options.find(opt => opt.id === selected.id)) {
              options.push({
                ...selected,
                label: selected.label || `${selected.code || ""} - ${selected.name || ""}`
              });
            }
          });

          this.optionWarehouseArea = options;

          this.items.forEach(item => {
            const selectedId = item.warehouseArea.selected && item.warehouseArea.selected.id;
            if (selectedId) {
              const found = options.find(opt => opt.id === selectedId);
              if (found) {
                item.warehouseArea.selected = found;
              }
            }
          });
        }
      });
    },
    fetchItemsEdit(index, warehouseID, warehouseAreaID) {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/wms/item-stock/group-items", {
          params: {
            order: "item_name",
            sort: "asc",
            warehouse_id: warehouseID,
            warehouse_area_id: warehouseAreaID,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const options = resp.data.records.map(item => ({
              ...item,
              label: `${item.sku_code} - ${item.item_name}`,
            }));
            this.items[index].sku.options = options;

            const selected = this.items[index].sku.selected;
            if (selected && selected.sku_code) {
              let found = options.find(opt => opt.sku_code === selected.sku_code);
              if (!found) {
                found = {
                  sku_code: selected.sku_code,
                  item_name: selected.item_name,
                  label: `${selected.sku_code} - ${selected.item_name}`
                };
                options.push(found);
                this.items[index].sku.options = options;
              }
              this.items[index].sku.selected = found;
            }
          }
        });
    },
    fetchBatchExternalEdit(index, warehouseID, warehouseAreaID, skuCode) {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/wms/item-stock/group-batch", {
          params: {
            warehouse_id: warehouseID,
            warehouse_area_id: warehouseAreaID,
            sku_code: skuCode,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const options = resp.data.records.map(item => ({
              ...item,
              label: `${item.batch_external} / ${item.expired_date ? moment(item.expired_date).format('YYYY-MM-DD') : ''}`
            }));
            this.items[index].batchExternal.options = options;

            const selected = this.items[index].batchExternal.selected;
            if (selected && selected.batch_external && selected.expired_date) {
              const found = options.find(opt =>
                opt.batch_external === selected.batch_external &&
                moment(opt.expired_date).format('YYYY-MM-DD') === moment(selected.expired_date).format('YYYY-MM-DD')
              );
              if (!found) {
                const label = `${selected.batch_external} / ${selected.expired_date ? moment(selected.expired_date).format('YYYY-MM-DD') : ''}`;
                const fallback = {
                  batch_external: selected.batch_external,
                  expired_date: selected.expired_date,
                  label: label
                };
                options.push(fallback);
                this.items[index].batchExternal.options = options;
                this.items[index].batchExternal.selected = fallback;
              } else {
                this.items[index].batchExternal.selected = found;
              }
            }
          }
        });
    },
    fetchDateInEdit(index, warehouseID, warehouseAreaID, skuCode, batchExternal) {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/wms/item-stock/get-date-in", {
          params: {
            warehouse_id: warehouseID,
            warehouse_area_id: warehouseAreaID,
            sku_code: skuCode,
            batch_external: batchExternal,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const options = resp.data.records.map(item => ({
              ...item,
              label: item.in_time ? moment(item.in_time).format('YYYY-MM-DD') : ''
            }));
            this.items[index].dateIn.options = options;

            const selected = this.items[index].dateIn.selected;
            if (selected && (selected.in_time || selected.date_in)) {
              const selectedDate = moment(selected.in_time || selected.date_in).format('YYYY-MM-DD');
              let found = options.find(opt =>
                moment(opt.in_time).format('YYYY-MM-DD') === selectedDate
              );
              if (!found) {
                found = {
                  in_time: selected.in_time || selected.date_in,
                  expired_date: selected.expired_date,
                  label: selectedDate
                };
                options.push(found);
                this.items[index].dateIn.options = options;
              }
              this.items[index].dateIn.selected = found;
            }
          }
        });
    },
    fetchUnitEdit(index, warehouseID, warehouseAreaID, skuCode, expiredDate, batchExternal, dateIn) {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/wms/item-stock/get-unit-available", {
          params: {
            warehouse_id: warehouseID,
            warehouse_area_id: warehouseAreaID,
            sku_code: skuCode,
            expired_date: expiredDate,
            batch_external: batchExternal,
            date_in: dateIn,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const options = resp.data.records.map(item => ({
              ...item,
              label: item.unit
            }));
            this.items[index].unit.options = options;

            const selected = this.items[index].unit.selected;
            if (selected && selected.unit) {
              let found = options.find(opt => opt.unit === selected.unit);
              if (!found) {
                found = {
                  unit: selected.unit,
                  label: selected.unit
                };
                options.push(found);
                this.items[index].unit.options = options;
              }
              this.items[index].unit.selected = found;
            }
          }
        });
    },
    fetchQtyAvailableEdit(index, warehouseID, warehouseAreaID, skuCode, expiredDate, batchExternal, dateIn, unit) {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/wms/item-stock/qty-available", {
          params: {
            warehouse_id: warehouseID,
            warehouse_area_id: warehouseAreaID,
            sku_code: skuCode,
            expired_date: expiredDate,
            batch_external: batchExternal,
            date_in: dateIn,
            unit: unit,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            this.items[index].qty = resp.data.amount;
            this.items[index].qtyUom = resp.data.amount * resp.data.amount_uom;
            this.fetchNewUnit(this.items[index].sku.selected.sku_code, index);
          }
        });
    },
    fetchNewUnitEdit(sku_code, index) {
      this.$vs.loading();
      this.$http
        .get("/api/wms/v1/master/item-unit-sku-code", {
          params: {
            sku_code: sku_code,
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code === 200) {
            const options = resp.data.records.map(item => ({
              ...item,
              label: item.name
            }));
            this.items[index].newUnitOptions = options;

            this.items[index].line.forEach(line => {
              const selected = line.newUnit.selected;
              if (selected && selected.name) {
                const found = options.find(opt => opt.name === selected.name);
                if (found) {
                  line.newUnit.selected = found;
                }
              }
            });
          }
        });
    },
    calculateTotalNewQtyUom(indextr) {
      const item = this.items[indextr];
      let total = 0;
      item.line.forEach(line => {
        if (line.newQtyUom && !isNaN(line.newQtyUom)) {
          total += parseFloat(line.newQtyUom);
        }
      });
      this.items[indextr].totalNewQtyUom = total;
    },
    dateFormat(date) {
      return date ? moment(date).format('YYYY-MM-DD') : '';
    }
  },
  mounted() {
    if (this.isEditMode) {
      this.getData();
    }
  },
  watch: {
    notes(val) {
      if (typeof val === "string" && val.length > 255) {
        this.notes = val.slice(0, 255);
      }
    }
  },
  computed: {
    isEditMode() {
      return this.id !== null;
    },
  },
}
</script>

<style>
.datepicker-above {
  position: absolute !important;
  bottom: 100% !important;
  top: auto !important;
  margin-bottom: 8px !important;
  z-index: 9999;
}
</style>
